import React from "react"
import get from "lodash/get"
import includes from "lodash/includes"
import image from "../../../../images/application2/OrdersProcessing.png"
import {axios, tt} from "@lib/helpers"
import {loadPayments} from "@payjp/payments-js"

const AppPurchaseRecordGmoSecure: ReactFC<PropTypes> = ({data}) => {
  const {api_key, paths, point_purchase, t} = data

  const [payments, setPayments] = React.useState<any>(null)

  const book = () => {
    axios.post(paths.purchase_recording_booking_path).finally(() => {
      window.location.href = paths.purchase_recording_booking_path
    })
  }

  React.useEffect(() => {
    loadPayments(api_key).then(setPayments)
  }, [api_key])

  React.useEffect(() => {
    if (!payments) return

    let isMounted = true

    const poller = () => {
      axios
        .get(paths.point_purchase_path)
        .then((res: any) => {
          if (!isMounted) return

          const status = res?.data?.data?.status

          if (includes(["success"], status)) {
            book()
          } else if (includes(["error"], status)) {
            window.location.href = paths.purchase_recording_booking_path
          } else if (includes(["requires_action"], status)) {
            const clientSecret = res?.data?.data?.payjp_client_secret

            if (clientSecret && payments) {
              payments
                .handleNextAction({clientSecret})
                .then((result: any) => {
                  console.log("handleNextAction result:", result)
                  book()
                })
                .catch((err: any) => {
                  console.error("handleNextAction error:", err)
                  window.location.href = paths.purchase_recording_booking_path
                })
            }
          } else {
            setTimeout(poller, 1000)
          }
        })
        .catch((error) => {
          window.location.href = paths.purchase_recording_booking_path
        })
    }

    poller()

    return () => {
      isMounted = false
    }
  }, [payments, paths]) // 依存配列は適切に調整

  return (
    <div className="AppSecureTransaction">
      <h1 className="App__h1">{tt(t, "title")}</h1>
      <div className="AppSecureTransaction__body">
        <img
          className="AppSecureTransaction__body__img AppSecureTransaction__body__img--animate"
          src={image}
          alt="Order processing"
          style={{
            width: "82px",
            height: "82px",
          }}
        />

        <p className="AppSecureTransaction__body__p">{tt(t, "p1")}</p>

        <p className="AppSecureTransaction__body__p AppSecureTransaction__body__p--red">
          {tt(t, "p2")}
        </p>
      </div>
    </div>
  )
}

export default AppPurchaseRecordGmoSecure
